import { Fragment } from "react";
import { H5 } from "../../../../../../../AbstractElements";
import { Categories, NewProducts, Price } from "../../../../../../../Constants/Constants";
import GenderFilter from "./GenderFilter";
import BrandFilter from "./BrandFilter";
import ColorsFilter from "./ColorsFilter";
import RangeSlider from "./RangeSlider";

const Category = () => {
  return (
    <Fragment>
      <div className="product-filter">
        <H5>{Categories}</H5>
        <GenderFilter />
      </div>
      <BrandFilter />
      <ColorsFilter />
      <div className="product-filter pb-0 price-range">
        <H5>{Price}</H5>
        <RangeSlider />
        <H5 className="mt-5">{NewProducts}</H5>
      </div>
    </Fragment>
  );
};

export default Category;
